import React from 'react';
import { useImage } from 'common/hooks';

import { Container, Image } from './elements';

type Props = {
  readonly className?: string;
  readonly imagePath: string;
  readonly colors: { primary: string; secondary: string };
};

function CategoryImage({
  className,
  imagePath,
  colors,
}: Props): React.ReactElement {
  const [imageUrl] = useImage(imagePath);

  return (
    <Container className={className} colors={colors}>
      <Image src={imageUrl} />
    </Container>
  );
}

export default CategoryImage;
